import { Airport } from '@sd-portal/shared/airport';
import { Moment } from 'moment';

export class StaffInfo {
  staffInfoId: number | null;
  homeBase: Airport | null = null;
  employeeStatusId: number | null = null;
  certificateNumber: string | null = null;
  hireDate: Moment | string | null = null;
}

export const isStaffInfoSaved = (obj: StaffInfo) => {
  return obj.staffInfoId && obj.staffInfoId > 0;
};
